// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import PageHeader from "../../components/PageHeader";
import PageTitle from "../../components/PageTitle";
import PageBody from "../../components/PageBody";
import SettingsForm from "./SettingsForm";
import { RouteComponentProps } from "@reach/router";
import { AuthentifiedUser } from "../../../api/backend-openapi";
import { useStore } from "effector-react";
import { authentifiedUserStore } from "../../../state/auth/AuthStore";
import { NboAction } from "../../types/AuthTypes";

const SettingsScreen: React.FunctionComponent<RouteComponentProps> = () => {
  const { t } = useTranslation();
  const [editMode, setEditMode] = useState<boolean>(false);

  const authentifiedUser: AuthentifiedUser | null = useStore(
    authentifiedUserStore
  );
  const canEdit: boolean =
    authentifiedUser?.rights.nboSetting?.includes(NboAction.nboUpdate) || false;
  return (
    <>
      <PageHeader>
        <PageTitle
          title={t(editMode ? "settings.edit.title" : "settings.title")}
        />
      </PageHeader>
      <PageBody>
        <SettingsForm
          editMode={editMode}
          setEditMode={setEditMode}
          canEdit={canEdit}
        />
      </PageBody>
    </>
  );
};

export default SettingsScreen;
